import { Host, h, } from "@stencil/core";
import { formMessageLogic } from "../../common/form";
import { formClasses } from "../../common/classesNames";
export class GxgFormCheckboxGroup {
    constructor() {
        this.disabled = false;
        this.row = undefined;
        this.validationStatus = "indeterminate";
        this.validationMessage = undefined;
        this.informationMessage = undefined;
    }
    el;
    groupValuesChanged;
    watchDisabledHandler(disabled) {
        if (disabled) {
            this.disableGroup();
        }
        else {
            this.enableGroup();
        }
    }
    /**
     * Returns CheckboxesGroupValues = CheckboxInfo[];
     */
    async getValues() {
        return this.getCheckboxesInfo();
    }
    componentWillLoad() {
        if (this.disabled) {
            this.disableGroup();
        }
    }
    changeHandler(event) {
        if (!event.detail.disabled) {
            //If it was changed because it is disabled, do not emit
            const checkboxesGroupInfo = this.getCheckboxesInfo();
            this.groupValuesChanged.emit(checkboxesGroupInfo);
        }
    }
    getCheckboxesInfo = () => {
        const checkboxesArray = [];
        const checkboxes = this.el.querySelectorAll("gxg-form-checkbox");
        checkboxes.forEach((checkbox) => {
            checkboxesArray.push({
                id: checkbox.checkboxId,
                value: checkbox.checked,
                disabled: checkbox.disabled,
            });
        });
        return checkboxesArray;
    };
    disableGroup = () => {
        const allCheckboxes = this.el.querySelectorAll("gxg-form-checkbox");
        allCheckboxes.forEach((checkbox) => {
            checkbox.disabled = true;
        });
    };
    enableGroup = () => {
        const allCheckboxes = this.el.querySelectorAll("gxg-form-checkbox");
        allCheckboxes.forEach((checkbox) => {
            checkbox.disabled = false;
        });
    };
    render() {
        return (h(Host, null, h("div", { class: {
                "checkboxes-wrapper": true,
                "checkboxes-wrapper--row": this.row,
                [formClasses["VALIDATION_INDETERMINATE_CLASS"]]: this.validationStatus === "indeterminate",
                [formClasses["VALIDATION_WARNING_CLASS"]]: this.validationStatus === "warning",
                [formClasses["VALIDATION_ERROR_CLASS"]]: this.validationStatus === "error",
                [formClasses["VALIDATION_SUCCESS_CLASS"]]: this.validationStatus === "success",
            } }, h("slot", null)), formMessageLogic(this)));
    }
    static get is() { return "gxg-form-checkbox-group"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["gxg-form-checkbox-group.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["gxg-form-checkbox-group.css"]
        };
    }
    static get properties() {
        return {
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute makes all the checkboxes disabled"
                },
                "attribute": "disabled",
                "reflect": false,
                "defaultValue": "false"
            },
            "row": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute makes the checkboxes be displayed with flex \"row\", instead of flex \"column\""
                },
                "attribute": "row",
                "reflect": false
            },
            "validationStatus": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "ValidationStatus",
                    "resolved": "\"error\" | \"indeterminate\" | \"success\" | \"warning\"",
                    "references": {
                        "ValidationStatus": {
                            "location": "import",
                            "path": "../../common/types",
                            "id": "src/common/types.ts::ValidationStatus"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The validation status"
                },
                "attribute": "validation-status",
                "reflect": false,
                "defaultValue": "\"indeterminate\""
            },
            "validationMessage": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The required message if this input is required and no value is provided (optional). If this is not provided, the default browser required message will show up"
                },
                "attribute": "validation-message",
                "reflect": false
            },
            "informationMessage": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "An informative message to help the user filling the information"
                },
                "attribute": "information-message",
                "reflect": false
            }
        };
    }
    static get events() {
        return [{
                "method": "groupValuesChanged",
                "name": "groupValuesChanged",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "CheckboxesGroupValues",
                    "resolved": "CheckboxInfo[]",
                    "references": {
                        "CheckboxesGroupValues": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/form-checkbox-group/gxg-form-checkbox-group.tsx",
                            "id": "src/components/form-checkbox-group/gxg-form-checkbox-group.tsx::CheckboxesGroupValues"
                        }
                    }
                }
            }];
    }
    static get methods() {
        return {
            "getValues": {
                "complexType": {
                    "signature": "() => Promise<CheckboxesGroupValues>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        },
                        "CheckboxesGroupValues": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/form-checkbox-group/gxg-form-checkbox-group.tsx",
                            "id": "src/components/form-checkbox-group/gxg-form-checkbox-group.tsx::CheckboxesGroupValues"
                        }
                    },
                    "return": "Promise<CheckboxesGroupValues>"
                },
                "docs": {
                    "text": "Returns CheckboxesGroupValues = CheckboxInfo[];",
                    "tags": []
                }
            }
        };
    }
    static get elementRef() { return "el"; }
    static get watchers() {
        return [{
                "propName": "disabled",
                "methodName": "watchDisabledHandler"
            }];
    }
    static get listeners() {
        return [{
                "name": "change",
                "method": "changeHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=gxg-form-checkbox-group.js.map
